import { render, staticRenderFns } from "./RealtimeWaitReservationPopup.vue?vue&type=template&id=1bfec4d0&"
import script from "./RealtimeWaitReservationPopup.vue?vue&type=script&lang=js&"
export * from "./RealtimeWaitReservationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports